import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) { navigate("/login", { replace: true }); return; }
    (async () => {
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "X-Session-ID": sid },
          credentials: "include",
        });
        if (!res.ok) throw new Error("auth failed");
        window.history.replaceState(null, "", "/espace-leads");
        navigate("/espace-leads", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-ocean-dark flex flex-col items-center justify-center text-white gap-4" data-testid="auth-callback">
      <Loader2 className="w-8 h-8 animate-spin text-gold" />
      <p className="text-sm text-white/60">Connexion en cours...</p>
    </div>
  );
}
